<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  responsible: { type: Object, default: () => ({}) },
  deadlines: { type: Array, default: () => [] },
});

const { t } = useI18n();
const buckets = [
  { id: 'amarelos', className: 'bg-amber-100 text-amber-800' },
  { id: 'laranjas', className: 'bg-orange-100 text-orange-800' },
  { id: 'vermelhos', className: 'bg-red-100 text-red-800' },
];

const deadlineCounts = computed(() =>
  buckets
    .map(bucket => ({
      ...bucket,
      count: props.deadlines.filter(deadline => deadline.bucket === bucket.id)
        .length,
    }))
    .filter(bucket => bucket.count)
);

const deadlineLabel = ({ id, count }) => {
  if (id === 'vermelhos') {
    if (count === 1)
      return t(
        'POST_SALE.AGENDA.SELECTED_COUNTS.OVERDUE_ONE'
      ).toLocaleUpperCase('pt-BR');

    return t(
      'POST_SALE.AGENDA.SELECTED_COUNTS.OVERDUE_OTHER'
    ).toLocaleUpperCase('pt-BR');
  }

  if (id === 'amarelos')
    return t('POST_SALE.DEADLINES.AMARELOS').toLocaleUpperCase('pt-BR');

  return t('POST_SALE.DEADLINES.LARANJAS').toLocaleUpperCase('pt-BR');
};
</script>

<template>
  <div class="mt-3 flex flex-wrap gap-2">
    <span
      class="rounded-full bg-lais-bg-soft px-2 py-0.5 text-[11px] font-semibold uppercase text-lais-text-body"
    >
      {{ responsible?.name || t('POST_SALE.COMMON.UNASSIGNED') }}
    </span>
    <span
      v-for="bucket in deadlineCounts"
      :key="bucket.id"
      :data-bucket="bucket.id"
      class="rounded-full px-2 py-0.5 text-[11px] font-semibold uppercase"
      :class="bucket.className"
    >
      {{ bucket.count }} {{ deadlineLabel(bucket) }}
    </span>
  </div>
</template>
